import jsurl from 'jsurl';

import {getProjectId, getReportUrl, getWorkspaceId} from 'common/report/util';
import {encodeQueryParams} from 'common/report/util/url';

export const getProfilePath = (distinctId, dataGroupId, params = {}) => {
  return `${getReportUrl(`profile`, {projectId: getProjectId(), workspaceId: getWorkspaceId()})}#${encodeQueryParams({
    ...(distinctId
      ? {
          distinct_id: distinctId,
        }
      : {}),
    ...(dataGroupId
      ? {
          data_group_id: dataGroupId,
        }
      : {}),
  })}&${Object.keys(params).length ? jsurl.stringify(params) : ``}`;
};
